import React from 'react';
import useAnalytics from 'helpers/useAnalytics';
import makeStyles from '@material-ui/core/styles/makeStyles';
import WidgetTypeCard from 'pages/Homepage/components/WidgetTypeCard';

import {
  RICH_TEXT_TYPE_ID,
  MY_TEAM_TYPE_ID,
  PERSONS_LISTS_BY_DATE_TYPE_ID,
} from 'pages/Homepage/helpers/consts';

function WidgetSelectType() {
  const classes = useStyles();
  const analytics = useAnalytics();

  const handleWidgetCardSelect = (widgetTypeId: string) => {
    if (widgetTypeId === MY_TEAM_TYPE_ID) {
      analytics.track('My Team widget type clicked', {
        category: 'AD - Homepage',
      });
    }

    if (widgetTypeId === RICH_TEXT_TYPE_ID) {
      analytics.track('Rich Text widget type clicked', {
        category: 'AD - Homepage',
      });
    }

    if (widgetTypeId === PERSONS_LISTS_BY_DATE_TYPE_ID) {
      analytics.track('People List by Date widget type clicked', {
        category: 'AD - Homepage',
      });
    }
  };

  return (
    <div className={classes.cards}>
      <WidgetTypeCard itemName="rich-text" link onClick={handleWidgetCardSelect} />
      <WidgetTypeCard itemName="my-team" link onClick={handleWidgetCardSelect} />
      <WidgetTypeCard itemName="person-lists-by-date" link onClick={handleWidgetCardSelect} />
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  cards: {
    display: 'flex',
  },
}));

export default WidgetSelectType;
